import { render } from "./DuelCountdown.vue?vue&type=template&id=d103c348&scoped=true"
import script from "./DuelCountdown.vue?vue&type=script&lang=js"
export * from "./DuelCountdown.vue?vue&type=script&lang=js"

import "./DuelCountdown.vue?vue&type=style&index=0&id=d103c348&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d103c348"]])

export default __exports__